import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { background_onboarding, logo } from '../../constants/icons';

// TP-Coach-Mandate — mirror of PlayerMandateDeclined (staff/coach wording).
const StaffMandateDeclined = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams();

  const { inviteParams, rawQuery } = location.state || {};

  const sharedState = useMemo(
    () => ({
      inviteParams,
      rawQuery,
    }),
    [inviteParams, rawQuery]
  );

  const handleTryAgain = () => {
    const mandatePath = token
      ? `/staff-register-mandate/${token}`
      : '/staff-register-mandate';

    navigate(mandatePath, {
      state: sharedState,
    });
  };

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
      style={{
        backgroundImage: `url(${background_onboarding})`,
      }}
    >
      <div className="bg-white p-8 w-full max-w-[544px] flex flex-col rounded-xl gap-6 items-center text-center">
        <img src={logo} alt="Transfer Pitch" className="h-10 mb-2 mx-auto" />
        <div className="flex items-center justify-center w-20 h-20 bg-orange-100 rounded-full mb-4">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#EA580C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <div>
          <div className="text-[#1A212F] text-2xl font-bold mb-4">
            Representation Declined
          </div>
          <div className="text-[#1A212F] text-base mb-6">
            You have declined the representation invitation. No agreement has been established.
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 w-full text-left">
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-5 h-5 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <span className="font-medium text-orange-800">What this means</span>
          </div>
          <ul className="text-sm text-orange-700 space-y-1">
            <li>• No representation agreement has been created</li>
            <li>• The agent has been notified of your decision</li>
            <li>• You can still be contacted for future opportunities</li>
          </ul>
        </div>

        <div className="w-full space-y-3">
          <button
            type="button"
            onClick={handleTryAgain}
            className="w-full h-[44px] rounded-lg bg-[#2283FF] hover:bg-[#1a6cd4] text-white text-[14px] font-medium transition-colors"
          >
            Review Again
          </button>
          {/* No close button: the page is opened from a mail link, so
              window.close() is refused by the browser. Review Again is the
              working way on, matching the sibling KYC-rejected page. */}
        </div>
      </div>
    </div>
  );
};

export default StaffMandateDeclined;
